import { render, staticRenderFns } from "./deviceAccess.vue?vue&type=template&id=60f5b01e"
import script from "./deviceAccess.vue?vue&type=script&lang=js"
export * from "./deviceAccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports